import 'projects/sharedComponents/src/pet/productType/productTypePill.scss';

import { Chip } from '@mui/material';
import { FC } from 'react';
import { ProductType } from 'projects/sharedComponents/src/generated/graphql-client-types';

type ProductTypePillProps = {
  productLabel: string;
};

export const productTypeToLabelMap: { [key in ProductType]: string } = {
  [ProductType.Purebred]: 'Purebred Test',
  [ProductType.ComprehensiveConsumer]: 'Breed & Health Test',
  [ProductType.BreedAndAncestry]: 'Breed ID Test',
  [ProductType.ComprehensiveUpgrade]: 'Breed & Health Test',
  [ProductType.Vet]: 'Breed & Health Test',
  [ProductType.ComprehensiveBreeder]: 'Breed & Health Test',
};

export const ProductTypePill: FC<ProductTypePillProps> = ({ productLabel }) => {
  return <Chip className="productTypePill" variant="outlined" label={productLabel} />;
};
